import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import{HttpClientModule} from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { ToastrModule } from 'ngx-toastr';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { DatePipe } from '@angular/common';
import { SalesreportComponent } from './salesreport/salesreport.component';
import { PurchasereportComponent } from './purchasereport/purchasereport.component';
import { StockreportComponent } from './stockreport/stockreport.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

import { StockexchangeComponent } from './stockexchange/stockexchange.component';
import { SalesapprovalComponent } from './salesapproval/salesapproval.component';
import { StockCheckingApprovalComponent } from './StockChecking-Approval/stock-checking-approval/stock-checking-approval.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    DashboardComponent,
SalesreportComponent,
    PurchasereportComponent,
  
    StockreportComponent,


    StockexchangeComponent,
  
    SalesapprovalComponent,
  
    StockCheckingApprovalComponent

  ],
  imports: [
     FormsModule,
    BrowserModule,
    AppRoutingModule,
      BrowserModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatToolbarModule,
   MatInputModule,
   MatSelectModule,
    AppRoutingModule,
   FormsModule,
  
   ReactiveFormsModule,
  ToastrModule.forRoot(),
    MatNativeDateModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    HttpClientModule,
     MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    NgxChartsModule,
      MatExpansionModule,
     BrowserAnimationsModule,
    
    
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
